<template>
	<div v-if="showLoader" class="mobile-spinnerstyle">
		<MobileSpinner />
	</div>
	<div v-else-if="AllowedMobAndLap">
		<div class="mobileScreen-main-container">
			<MobileHeader />
			<div v-if="Loaderstatus" class="global-loader-overlay">
				<MobileSpinner />
			</div>
			<div class="mobileScreen-main-innerContainer">
				<div class="mobileScreen-TD-head m-3">
					Test Details
				</div>
				<hr />

				<div class="mobileScreen-TD-mainBody">
					<div>
						<div class="mobileScreen-TD-body-head">Test Name</div>
						<div
							class="mt-1 mobileScreen-TD-body-new-subhead"
							style="word-wrap: break-word;"
						>
							{{ testDetails.name }}
						</div>
					</div>

					<div class="mt-3">
						<div class="mobileScreen-TD-body-head">Test Description</div>
						<div
							class="mt-1 mobileScreen-TD-body-new-subhead"
							style="word-wrap: break-word;"
							v-html-safe="testDetails.config.testDesc"
						></div>
					</div>

					<div class="mt-3" v-if="testDetails.config.testInst != ''">
						<div class="mobileScreen-TD-body-head">Test Instructions</div>
						<div
							class="mt-1 mobileScreen-TD-body-new-subhead"
							style="word-wrap: break-word;"
							v-html-safe="testDetails.config.testInst"
						></div>
					</div>

					<div class="mt-3">
						<div class="mobileScreen-TD-body-head">Test Organizer</div>
						<div
							class="mt-1 mobileScreen-TD-body-new-subhead"
							style="word-wrap: break-word;"
						>
							{{ testDetails.config.testOrg }}
						</div>
					</div>

					<div class="mt-3">
						<div class="mobileScreen-TD-otherInfo mt-2">
							<div>
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/calendarstartDate.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">
											Start Date
										</div>
										<div class="mobileScreen-TD-otherInfo-subhead mt-1">
											{{
												convertToIST(testDetails.config.openTestdt).slice(
													13,
													22
												)
											}},
											{{
												formatDate(testDetails.config.openTestdt, "dd-MM-yyyy")
											}}
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2">
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/calendarstartDate.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">End Date</div>
										<div class="mobileScreen-TD-otherInfo-subhead mt-1">
											{{
												convertToIST(testDetails.config.closeTestdt).slice(
													13,
													22
												)
											}},
											{{
												formatDate(testDetails.config.closeTestdt, "dd-MM-yyyy")
											}}
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2">
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/hourglass-highduration.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">Duration</div>
										<div class="mobileScreen-TD-otherInfo-subhead mt-1">
											{{ testDetails.config.testDuration }} Minutes
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2">
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/repeatattempts.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">
											Total Attempts
										</div>
										<div
											class="mobileScreen-TD-otherInfo-subhead mt-1 d-flex align-items-center"
										>
											<div>{{ testDetails.config.maxnoattempts }}</div>
										</div>
									</div>
								</div>
							</div>

							<div
								class="mt-2"
								v-if="
									testDetails.config.timebnvalue != null &&
										testDetails.config.maxnoattempts > 1
								"
							>
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/repeatattempts.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">
											Time Between Attempts
										</div>
										<div
											class="mobileScreen-TD-otherInfo-subhead mt-1 d-flex align-items-center"
										>
											{{ testDetails.config.timebnvalue }}
											{{
												testDetails.config.timebnsel == "mins"
													? "Minutes"
													: testDetails.config.timebnsel == "hrs"
													? "Hours"
													: "Days"
											}}
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2">
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/list-detailstotal-questions.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">
											Total Questions
										</div>
										<div class="mobileScreen-TD-otherInfo-subhead mt-1">
											{{ testDetails.noOfQuestions }}
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2">
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/list-detailstotal-questions.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">
											Total Marks
										</div>
										<div class="mobileScreen-TD-otherInfo-subhead mt-1">
											{{ testDetails.marks }}
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2">
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/list-detailstotal-questions.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">
											Negative Marks
										</div>
										<div class="mobileScreen-TD-otherInfo-subhead mt-1">
											{{ testDetails.config.negativeMarkValue }}
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2">
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/calendarstartDate.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">
											Total Sections
										</div>
										<div class="mobileScreen-TD-otherInfo-subhead mt-1">
											{{ testDetails.numberOfSections }}
										</div>
									</div>
								</div>
							</div>

							<div class="mt-2">
								<div class="d-flex align-items-center">
									<div class="mb-4">
										<img
											src="../../assets/mobileScreenIcons/chart-bar 1diff-level.svg"
											alt=""
										/>
									</div>
									<div class="mt-1 ml-2">
										<div class="mobileScreen-TD-otherInfo-head">
											Difficulty Level
										</div>
										<div class="mobileScreen-TD-otherInfo-subhead mt-1">
											{{ testDetails.difficultyLevel }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="testDetails.config.communicationTest"
							class="comm-tst-banner mt-3 d-flex"
						>
							<div class="mr-3">
								<img src="../../assets/mobile-newUI-imgs/comm-tst-mob.svg" />
							</div>
							<div>
								<div class="cmtst-banner-hd">Communication Test</div>
								<div class="cmtst-banner-txt mt-1">
									Describe the picture in your own words using keywords given
									below
								</div>
							</div>
						</div>
						<template>
							<div class="position-relative mt-4">
								<hr style="border-top: 1px solid #ced1d4" class="my-3" />
								<div
									class="font-lato fs-14 fw-600 color-595959 px-2 position-absolute"
									style="left: 40%; top: -12px; background: #eef3f7"
								>
									Contents
								</div>
							</div>
							<div
								v-for="(section, index) in sectionDetailsTD"
								:key="section.sectionID"
								class="section-card"
								:class="index == 0 ? 'mt-0' : 'mt-3'"
							>
								<!-- Header -->
								<div
									class="d-flex justify-content-between align-items-center pointer p-12px"
									v-b-toggle="'section-' + index"
									@click="toggleSection(index)"
								>
									<div class="fw-500 fs-14 font-lato text-black">
										{{ section.sectionName }}
									</div>

									<div class="d-flex align-items-center">
										<span class="mr-2"
											><span class="fw-400 font-mont fs-12 color-3a3c40"
												><img
													src="@/assets/totquestions.svg"
													alt=""
													class="mr-1"
												/>Total Questions: </span
											><span class="fw-500 font-mont fs-12 color-3a3c40">{{
												section.totalQuestions
											}}</span>
										</span>
										<img
											class="ml-2"
											:class="{
												rotateArrow: activeSection !== index,
												rotateddown: activeSection === index,
											}"
											src="@/assets/filteruparw.svg"
										/>
									</div>
								</div>

								<!-- Collapse -->
								<b-collapse
									:id="'section-' + index"
									accordion="section-accordion"
									class="section-accordion"
								>
									<div class="dashed-divider-td"></div>
									<div class="section-body p-12px">
										<div class="d-flex flex-wrap">
											<div
												v-for="level in section.difficultyBreakdown.filter(
													(level) => level.questions > 0
												)"
												:key="level.level"
												class="level-item mr-3"
											>
												<span class="fs-12">
													<img src="@/assets/level.svg" alt="" />
													<span class="fw-400">{{ level.level }} : </span>
													<span class="fw-500">{{ level.questions }}</span>
												</span>
											</div>
										</div>
									</div>
								</b-collapse>
							</div>
						</template>
					</div>
				</div>
				<div
					class="mobileScreen-TD-footer d-flex align-items-center justify-content-between bluebtns"
				>
					<b-button
						class="mobileScreen-leaveBtn mr-3"
						@click="$bvModal.show('mobileLeaveTest')"
						>Leave Test</b-button
					>
					<b-button
						v-if="pricingDetails && pricingDetails.setPricing && !purchasedTest"
						class="mobileScreen-startBtn"
						@click="purchaseTest"
						><template
							v-if="
								pricingDetails.pricingData.finalPrice !==
									pricingDetails.pricingData.listPrice
							"
						>
							<span class="right-container-subhead">
								₹{{ pricingDetails.pricingData.finalPrice }}
							</span>

							<span
								style="font-family: 'Montserrat',sans-serif;font-weight: 400;font-size: 13px;text-decoration-line: line-through;color: #999999;"
							>
								₹{{ pricingDetails.pricingData.listPrice }}
							</span>
						</template>
						<span v-else>₹{{ pricingDetails.pricingData.finalPrice }}</span>

						<span class="mx-1">
							<img src="@/assets/icons/line.svg" alt="" />
						</span>
						Buy Now</b-button
					>
					<b-button class="mobileScreen-startBtn" @click="next()" v-else
						>Continue</b-button
					>
				</div>
			</div>
		</div>
		<b-modal id="mobileLeaveTest" centered hide-footer hide-header class="p-0">
			<div class="d-flex align-items-center justify-content-center flex-column">
				<div>
					<img
						src="../../assets/mobile-newUI-imgs/new-warning-icon.svg"
						alt=""
					/>
				</div>

				<div class="mt-4 mobileScreen-modal-head">
					Alert!
				</div>

				<div class="mt-3 mobileScreen-modal-subhead text-center">
					Are you sure you want to leave the test ? <br />
					**Please note this action cannot be undone**
				</div>

				<div
					class="mt-4 bluebtns d-flex align-items-center justify-content-center flex-column w-100"
				>
					<div class="w-50">
						<b-button
							class="mobileScreen-startBtn w-100"
							@click="$bvModal.hide('mobileLeaveTest')"
							>Cancel</b-button
						>
					</div>
					<div class="w-50">
						<b-button @click="leave()" class="mobileScreen-leaveBtn mt-3 w-100"
							>Leave Test</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>
		<div style="display: none" ref="responseContainer"></div>
	</div>

	<Block v-else />
</template>

<script>
import MobileHeader from "./MobileHeader.vue";
import testDetails from "../../mixins/testDetails";
import Block from "./Block.vue";
import { candidateSystemCheck } from "../../apiFunction";
import MobileSpinner from "../fixedcomponents/MobileSpinner.vue";
import payment from "../../mixins/payment.js";
export default {
	name: "TestDetails",
	mixins: [testDetails, payment],
	components: {
		MobileHeader,
		Block,
		MobileSpinner,
	},
	data: () => ({
		property: "value",
		AllowedMobAndLap: false,
		showLoader: true,
		activeSection: null,
		purchasedTest: false,
	}),
	async created() {
		await this.getMobileVerification();
		this.showLoader = false;
	},
	methods: {
		toggleSection(index) {
			this.activeSection = this.activeSection === index ? null : index;
		},
		async getMobileVerification() {
			try {
				let res = await candidateSystemCheck(`?uuid=${this.$route.query.uuid}`);
				console.log(res.data.data.Detail);
				this.AllowedMobAndLap = true;
			} catch (error) {
				this.AllowedMobAndLap = false;
			}
		},
	},
};
</script>

<style scoped>
.recClass {
	margin-top: -245px;
}
.recClassModel {
	margin-top: -210px;
}
.modal-content {
	position: relative;
	display: flex;
	flex-direction: column;
	width: 90%;
	pointer-events: auto;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 20px;
	outline: 0;
	margin: auto;
}
.mtd-detail-container ::-webkit-scrollbar-track {
	border-radius: 10px;
	background: #eeeeee;
}
.mtd-detail-container ::-webkit-scrollbar-thumb {
	background: #72738e;
	border-radius: 10px;
}
.mtd-detail-container ::-webkit-scrollbar {
	width: 5px;
}
.global-loader-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	backdrop-filter: blur(6px); /* actual blur */
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 99999;
}
</style>
